import React from 'react';

const NoOrdersFound = () => {
    return <div className="text-center">
        <img src={window.location.origin + "/images/no-orders-yet.png"} width="300" />
    </div>;
}

export default NoOrdersFound;